import React from "react";

/**
 * Generic error boundary so a single-component crash (e.g. a missing useState
 * in a child like ClinicalSnapshotEditor) doesn't blank out the whole page.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught error:", error, info);
  }

  reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="error-boundary-fallback"
          className="m-6 rounded-lg border border-rose-200 bg-rose-50 p-4 text-rose-900"
        >
          <div className="font-semibold mb-1">Something went wrong on this page.</div>
          <div className="text-sm text-rose-800 mb-3">
            {(this.state.error && (this.state.error.message || String(this.state.error))) ||
              "An unexpected error occurred."}
          </div>
          <button
            type="button"
            onClick={this.reset}
            data-testid="error-boundary-retry"
            className="px-3 py-1.5 rounded bg-rose-600 text-white text-sm hover:bg-rose-700"
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
